<mat-progress-spinner mode="indeterminate" [color]="color" [ngStyle]="{'display': 'inline-block'}"
                      *ngIf="display" [diameter]="diameter" [strokeWidth]="strokeWidth"></mat-progress-spinner>

